import type { SubscriptionStatus } from '~/services/subscription/getSubscriptionStatus';
import { formatAmount, formatLongDate, priceLabelFor } from '~/utils/trialPricing';

type ListFormatCtor = new (lang: string, opts: { style: string; type: string }) => { format(items: string[]): string };

/** « 1 novembre et 1 décembre » (Intl.ListFormat, repli sur des virgules). */
export function formatList(items: string[], lang: string): string {
    const { ListFormat } = Intl as unknown as { ListFormat?: ListFormatCtor };
    if (ListFormat) {
        try {
            return new ListFormat(lang, { style: 'long', type: 'conjunction' }).format(items);
        } catch {
            /* langue inconnue : repli */
        }
    }
    return items.join(', ');
}

/** Date Stripe (secondes Unix) → « 1 novembre ». */
export const unixDate = (seconds: number, lang: string) => formatLongDate(new Date(seconds * 1000), lang);

/** Montant mensuel à la reprise : prochaine facture (remises comprises), sinon prix catalogue. */
export function monthlyPrice(sub: Pick<SubscriptionStatus, 'nextAmount' | 'currency'> | null, lang: string): string {
    if (sub && typeof sub.nextAmount === 'number' && sub.nextAmount > 0 && sub.currency) {
        return formatAmount(sub.nextAmount, sub.currency, lang);
    }
    return priceLabelFor(sub?.currency);
}
